"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterBoxDateTime = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ArrowForward_1 = tslib_1.__importDefault(require("@mui/icons-material/ArrowForward"));
const DateRange_1 = tslib_1.__importDefault(require("@mui/icons-material/DateRange"));
const ExpandMore_1 = tslib_1.__importDefault(require("@mui/icons-material/ExpandMore"));
const ButtonGroup_1 = tslib_1.__importDefault(require("@mui/material/ButtonGroup"));
const styles_1 = require("@mui/material/styles");
const icons_1 = require("../icons");
const DateTimeFieldStrategy_1 = tslib_1.__importDefault(require("./DateTimeFieldStrategy"));
const DateTimeFilterQuickSelect_1 = tslib_1.__importDefault(require("./DateTimeFilterQuickSelect"));
const ButtonWithPopover_1 = tslib_1.__importDefault(require("./_InternalComponents/ButtonWithPopover"));
const DateTimeFilterEnd_1 = tslib_1.__importDefault(require("./_InternalComponents/DateTimeFilterEnd"));
const DateTimeFilterStart_1 = tslib_1.__importDefault(require("./_InternalComponents/DateTimeFilterStart"));
const getStyles = ({ theme, props }) => ({
    buttonGroup: {
        height: 48,
        "& .MuiButtonGroup-grouped:not(:first-of-type)": {
            border: "none",
        },
        "& .MuiButtonGroup-firstButton": {
            borderRight: `1px solid ${theme.palette.divider}`,
        },
    },
    quickActionIcon: {
        color: props.state === "normal" ? theme.palette.primary.main : null,
        ...theme.applyStyles("dark", {
            color: props.state === "normal" ? theme.palette.common.white : theme.palette.common.black,
        }),
    },
    quickActionButton: {
        p: 1,
        "& .MuiButton-endIcon": {
            margin: 0,
        },
        "& .MuiButton-startIcon": {
            margin: 0,
        },
    },
    arrowForward: {
        color: theme.palette.secondary.main,
        ...theme.applyStyles("dark", { color: theme.palette.common.white }),
    },
    arrowForwardError: {
        color: theme.palette.common.white,
    },
});
/**
 * @category component
 */
const FilterBoxDateTime = (props) => {
    const { open, value, state, onClick, onClose, onSubmit, onError, onChange, onTimeFieldStrategyChange, timeFieldStrategyOptions, timeFieldStrategyProps, startButtonText, startButtonPlaceholder, startAbsoluteTimeText, startErrorText, endButtonText, endButtonPlaceholder, endAbsoluteTimeText, endErrorText, quickSelectProps, startDateTimeFilterProps, endDateTimeFilterProps, ...rest } = (0, styles_1.useThemeProps)({
        props,
        name: "FilterBoxDateTime",
    });
    const anchorEl = react_1.default.useRef();
    const theme = (0, styles_1.useTheme)();
    const styles = getStyles({ theme, props: { state } });
    return (react_1.default.createElement(ButtonGroup_1.default, { ref: anchorEl, variant: "contained", sx: styles.buttonGroup, ...rest },
        react_1.default.createElement(ButtonWithPopover_1.default, { open: open === "quickSelect", onClose: onClose, anchorEl: anchorEl?.current, arrowOffset: 15, onRenderError: onError, ButtonProps: {
                state,
                sx: styles.quickActionButton,
                startIcon: react_1.default.createElement(DateRange_1.default, { sx: styles.quickActionIcon }),
                endIcon: react_1.default.createElement(ExpandMore_1.default, { sx: styles.quickActionIcon }),
                onClick: (e) => onClick(e, "quickSelect"),
            } },
            react_1.default.createElement(DateTimeFilterQuickSelect_1.default, { onSelect: (e, { start, end }) => onSubmit(e, { start, end }), sx: { maxWidth: 450 }, ...quickSelectProps })),
        react_1.default.createElement(ButtonWithPopover_1.default, { open: open === "start", onClose: onClose, anchorEl: anchorEl?.current, arrowOffset: 65, onRenderError: onError, ButtonProps: {
                state,
                sx: { textTransform: "none" },
                children: startButtonText || startButtonPlaceholder,
                onClick: (e) => onClick(e, "start"),
            } },
            react_1.default.createElement(DateTimeFilterStart_1.default, { value: { dateTime: value?.start }, onApply: (e, v) => onSubmit(e, { ...value, start: v.dateTime }), onCancel: (e) => onClose(e), onChange: (v) => onChange("start", v), absoluteTimeText: startAbsoluteTimeText, errorText: startErrorText, sx: { maxWidth: 450 }, ...startDateTimeFilterProps })),
        react_1.default.createElement(ButtonWithPopover_1.default, { open: open === "end", onClose: onClose, anchorEl: anchorEl?.current, arrowOffset: anchorEl?.current?.getBoundingClientRect()?.width - 75 > 450
                ? 445 // Points the arrow at the button when the FilterBox width is greater that the popover max width
                : anchorEl?.current?.getBoundingClientRect()?.width - 100, onRenderError: onError, ButtonProps: {
                state,
                sx: { textTransform: "none" },
                startIcon: react_1.default.createElement(ArrowForward_1.default, { sx: state === "error" ? styles.arrowForwardError : styles.arrowForward }),
                onClick: (e) => onClick(e, "end"),
                children: endButtonText || endButtonPlaceholder,
            } },
            react_1.default.createElement(DateTimeFilterEnd_1.default, { value: { dateTime: value?.end }, onApply: (e, v) => onSubmit(e, { ...value, end: v?.dateTime }), onCancel: (e) => onClose(e), onChange: (v) => onChange("end", v), absoluteTimeText: endAbsoluteTimeText, errorText: endErrorText, sx: { maxWidth: 450 }, ...endDateTimeFilterProps })),
        timeFieldStrategyOptions && (react_1.default.createElement(ButtonWithPopover_1.default, { open: open === "timeFieldStrategy", anchorEl: anchorEl?.current, anchorOrigin: { horizontal: "right", vertical: "bottom" }, transformOrigin: { horizontal: "right", vertical: "top" }, arrowOffset: 165, onClose: onClose, onRenderError: onError, ButtonProps: {
                state,
                endIcon: react_1.default.createElement(icons_1.FilterIcon, null),
                onClick: (e) => onClick(e, "timeFieldStrategy"),
            } },
            react_1.default.createElement(DateTimeFieldStrategy_1.default, { value: value?.timeFieldStrategy, options: timeFieldStrategyOptions, onChange: onTimeFieldStrategyChange, ...timeFieldStrategyProps })))));
};
exports.FilterBoxDateTime = FilterBoxDateTime;
exports.default = exports.FilterBoxDateTime;
